export default {
  image: 'RadioButtonsImages',
  button: 'radioButtonsList-2',
  default: 'dropdown',
  dropdown: 'dropdown',
};
